// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_9m-6";
export var headerCell = "_9m-2";
export var rowWrapper = "_9m-4";
export var stickyAggregationRow = "_9m-7";
export var table = "_9m-1";
export var virtualRowWrapper = "_9m-5";
export var virtualTableContainer = "_9m-0";
export var white = "_9m-3";